export const preferences = {
  title: '偏好設定',
  language: '語言',
  theme: '主題',
  notifications: '通知',
  saved: '偏好設定已成功儲存',
};